import { gql } from "@apollo/client";
import { USER_CREDENTIALS_FIELDS, USER_LOGIN_FIELDS } from "graphql/fragments";

const LOGIN = gql`
  ${USER_LOGIN_FIELDS}
  ${USER_CREDENTIALS_FIELDS}
  mutation UserLogin($email: String!, $password: String!, $redirectUrl: String) {
    userLogin(email: $email, password: $password, redirectUrl: $redirectUrl) {
      user {
        ...UserLoginFields
      }
      credentials {
        ...UserCredentialsFields
      }
      requiresOtp
      challengeToken
      otpSentAt
      cooldownPeriodSeconds
      redirectTo
    }
  }
`;

const VERIFY_OTP = gql`
  ${USER_LOGIN_FIELDS}
  ${USER_CREDENTIALS_FIELDS}
  mutation VerifyOtp($otp: String!, $challengeToken: String!, $redirectTo: String) {
    verifyOtp(otp: $otp, challengeToken: $challengeToken, redirectTo: $redirectTo) {
      user {
        ...UserLoginFields
      }
      credentials {
        ...UserCredentialsFields
      }
      redirectTo
    }
  }
`;

const RESEND_OTP = gql`
  mutation ResendOtp($challengeToken: String!) {
    resendOtp(challengeToken: $challengeToken) {
      challengeToken
      otpSentAt
      cooldownPeriodSeconds
    }
  }
`;

const REQUEST_PASSWORD_RESET = gql`
  mutation UserSendPasswordResetWithToken($email: String!, $redirectUrl: String!) {
    userSendPasswordResetWithToken(email: $email, redirectUrl: $redirectUrl) {
      message
    }
  }
`;

const RESET_PASSWORD = gql`
  mutation UserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetPasswordToken: String!
  ) {
    userUpdatePasswordWithToken(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetPasswordToken: $resetPasswordToken
    ) {
      credentials {
        accessToken
        client
        expiry
        tokenType
        uid
      }
    }
  }
`;

const LOGOUT = gql`
  mutation UserLogout {
    userLogout {
      user {
        id
      }
    }
  }
`;

export { LOGIN, VERIFY_OTP, REQUEST_PASSWORD_RESET, RESET_PASSWORD, LOGOUT, RESEND_OTP };
